import type { QueryClient } from "@tanstack/react-query";

// The history reads' cache keys and their invalidation (#1177), apart from the
// reads themselves (`spec-history.ts`) so the write paths — the one updater
// every Editor verb, clone and publish lands through (`applyEditorResult`) and
// `markSpecReadsStale` (rename, archive, push, unlink, version delete) — reach
// them without loading the history's server functions.
//
// **Every spec write marks them stale**: the header names the writer straight
// away (ADR-0028 decision 8), publish included, where Modsy forgot
// (Assumption 9), and an open drawer re-reads.

export const specHistoryQueryKeyPrefix = ["specifications", "history"] as const;

export const specVersionHistoryQueryKey = (specificationId: number, versionId: number) =>
  [...specHistoryQueryKeyPrefix, specificationId, "version", versionId] as const;

export const specVersionLastEditQueryKey = (specificationId: number, versionId: number) =>
  [...specHistoryQueryKeyPrefix, specificationId, "last-edit", versionId] as const;

/** A Change Summary's pages, one key per opening of step 2 (#1178). */
export const specChangeSummaryQueryKey = (
  specificationId: number,
  versionId: number,
  opening: number,
) => [...specHistoryQueryKeyPrefix, specificationId, "change-summary", versionId, opening] as const;

export type SpecHistoryTab = "core" | "base" | "community";

export const specListHistoryQueryKey = (tab: SpecHistoryTab) =>
  [...specHistoryQueryKeyPrefix, "list", tab] as const;

/** A spec write's effect on history: its own reads and the spec list's History. */
export function markSpecHistoryStale(queryClient: QueryClient, specificationId: number): void {
  void queryClient.invalidateQueries({
    queryKey: [...specHistoryQueryKeyPrefix, specificationId],
  });
  void queryClient.invalidateQueries({ queryKey: [...specHistoryQueryKeyPrefix, "list"] });
}
